import { all, put, takeLatest } from "redux-saga/effects";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* request(actions) {
    try {
        const { appState } = actions.payload;
        yield put(actionCreators.updateSuccess(appState));
    } catch (error) {
        const errStr = error.toString();
        logToSentry("app support post", {
            error,
            errStr,
            actionPayload: action.payload,
        });
    }
}

export { request };

export default (function* () {
    yield all([takeLatest(actionTypes.APP_STATE_UPDATE_REQUEST, request)]);
})();
